import React, { ReactElement } from 'react';
import { VStack, Text, HStack } from '@wegroup/design-system';

interface Props {
  title: string;
  description: string;
  rightElement?: ReactElement;
}

const AdvisoryReportTitleWithDescription: React.FC<Props> = ({
  title,
  description,
  rightElement,
}) => {
  return (
    <HStack justify="space-between">
      <VStack align="stretch">
        <Text textStyle="normalBodyMedium">{title}</Text>
        <Text color="gray.500">{description}</Text>
      </VStack>
      {rightElement}
    </HStack>
  );
};

export default AdvisoryReportTitleWithDescription;
